import { Component, OnInit, OnDestroy } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { IMyDpOptions, IMyDateModel } from "mydatepicker";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { saveAs } from "file-saver";
import { checkDate as checkDateUtil } from "../utils/format-util";
@Component({
  selector: "app-insurance-billing",
  templateUrl: "./insurance-billing.component.html",
})
export class InsuranceBillingComponent implements OnInit, OnDestroy {
  rowsData: any[] = [];
  columnsData: any = [];
  row: any = {};
  destroyComponent: any = {};
  totalItems = 0;
  maxSize = 10;
  maxSizeItem = 10;
  pageOrder: any = {};
  currentPage = 1;
  page: number;
  fromDate: any;
  toDate: any;
  errorMessage = "";
  public myDatePickerOptions1: IMyDpOptions = {
    dateFormat: "mmm d, yyyy",
    disableSince: { year: 0, month: 0, day: 0 },
    showClearDateBtn: false,
    editableDateField: false,
    firstDayOfWeek: "su",
  };
  public myDatePickerOptions2: IMyDpOptions = {
    dateFormat: "mmm d, yyyy",
    disableUntil: { year: 0, month: 0, day: 0 },
    showClearDateBtn: false,
    editableDateField: false,
    firstDayOfWeek: "su",
  };
  insurancedata = [];
  insurancevalue: any = "";

  constructor(
    private api: AppService,
    private supportService: SupportService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // this.setDateRange();
    this.getRowsData();
    this.generate();
    this.getColumnOrder();
    this.getallinsurance();
  }

  getallinsurance() {
    const data = {
      countryId: localStorage.getItem("countryId"),
    };
    this.api.getallinsurancebycountryByTcId(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.insurancedata = res["entity"];
        }
      }
    });
  }

  private getRowsData() {
    this.rowsData = [
      {
        title: "Patient Name",
        sorting: false,
        name: "patientFirstName",
        dateFitler: false,
      },
      {
        title: "Date of Service",
        sorting: false,
        name: "scheduledOnStr",
        dateFitler: true,
      },
      {
        title: "Insurance Company Name",
        sorting: false,
        name: "insuranceName",
        dateFitler: false,
      },
      {
        title: "Insurance Type",
        sorting: false,
        name: "insuranceType",
        dateFitler: false,
      },
      {
        title: "ID Number",
        sorting: false,
        name: "insuranceIdNumber",
        dateFitler: false,
      },
      {
        title: "Procedure",
        sorting: false,
        name: "procedureName",
        dateFitler: false,
        textbox: false,
      },
      {
        title: "Group ID",
        sorting: false,
        name: "insuranceGroupNumber",
        dateFitler: false,
      },
      {
        title: "Referring Physician",
        sorting: false,
        name: "physicianFirstName",
        dateFitler: false,
      },
      {
        title: "Physician DPI",
        sorting: false,
        name: "physiciandpi",
        dateFitler: false,
      },
      {
        title: "Physician TaxId",
        sorting: false,
        name: "physiciantaxid",
        dateFitler: false,
      },
      {
        title: "Amount",
        sorting: false,
        name: "amount",
        dateFitler: false,
        textbox: true,
      },
    ];
    this.row = {
      param1: "patientFirstName",
      param2: "scheduledOnStr",
      param3: "insuranceName",
      param4: "insuranceType",
      param5: "insuranceIdNumber",
      param6: "procedureName",
      param7: "insuranceGroupNumber",
      param8: "physicianFirstName",
      param9: "physiciandpi",
      param10: "physiciantaxid",
      param11: "amount",
      param12: "id",
    };
    this.pageOrder = {
      pageNumber: 1,
      pageRecord: this.maxSizeItem,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "scheduledOnStr",
      sortType: "desc",
      search: "",
    };
  }
  private setDateRange() {
    if (new Date().getMonth() === 0) {
      this.fromDate = {
        date: {
          year: new Date().getFullYear() - 1,
          month: 11,
          day: new Date().getDate(),
        },
      };
    } else {
      this.fromDate = {
        date: {
          year: new Date().getFullYear(),
          month: new Date().getMonth(),
          day: new Date().getDate(),
        },
      };
    }
    this.toDate = {
      date: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
      },
    };
  }
  private aggregateInsuranceInfo(obj) {
    obj["scheduleAppointment"]["insuranceName"] = "";
    obj["scheduleAppointment"]["insuranceType"] = "";
    obj["scheduleAppointment"]["IdNumber"] = "";
    obj["scheduleAppointment"]["groupId"] = "";
    for (let index = 0; index < obj["scheduleAppointment"]["schedInsurance"].length; index++) {
      console.log(obj["scheduleAppointment"]["schedInsurance"][index]["insurance"]["name"]);
      if(obj["scheduleAppointment"]["schedInsurance"].length > 1){
        if(obj["scheduleAppointment"]["insuranceName"]){
          obj["scheduleAppointment"]["insuranceName"] += ",";
        }
        if(obj["scheduleAppointment"]["insuranceType"]){
          obj["scheduleAppointment"]["insuranceType"] += ",";
        }
        if(obj["scheduleAppointment"]["IdNumber"]){
          obj["scheduleAppointment"]["IdNumber"] += ",";
        }
        if(obj["scheduleAppointment"]["groupId"]){
          obj["scheduleAppointment"]["groupId"] += ",";
        }
      }
      obj["scheduleAppointment"]["insuranceName"] += obj["scheduleAppointment"]["schedInsurance"][index]["insurance"]["name"];
      obj["scheduleAppointment"]["insuranceType"] += obj["scheduleAppointment"]["schedInsurance"][index]["insuranceType"]["type"];
      obj["scheduleAppointment"]["IdNumber"] += obj["scheduleAppointment"]["schedInsurance"][index]["insuranceIdNumber"];
      obj["scheduleAppointment"]["groupId"] += obj["scheduleAppointment"]["schedInsurance"][index]["insuranceGroupNumber"];

    }
  }

  private getColumnData(param?) {
    this.api.getAllInsurenceBillingBYTcId(param).subscribe(
      (res: any) => {
        this.columnsData = [];
        if (res && res.entity) {
          this.totalItems = res["count"];
          res.entity.forEach((obj) => {
            this.aggregateInsuranceInfo(obj);

            const param = this.getParamData(obj);
            this.columnsData.push(param);
            
          });
         
        }
      },
      (err) => {
        if (err.error.error === "invalid_token") {
          this.api.sessionOut(err);
        }
      }
    );
  }

  insuranceBillingPrintList: any;
  getInsuranceBillingPrintList() {
    const pageOrder = this.clearCacheItem("savePdf");
    const param = pageOrder;
    this.api.getAllInsurenceBillingBYTcId(param).subscribe((res: any) => {
      this.insuranceBillingPrintList = [];
      if (res && res.entity) {
        res.entity.forEach((obj) => {
          this.aggregateInsuranceInfo(obj);
        });
        
        this.insuranceBillingPrintList = res.entity;

        console.log(this.insuranceBillingPrintList);
        setTimeout(() => {
          document.getElementById("printButton").click();
        }, 1000);
        
      }
    });
  }

  private getParamData(obj) {
    const param: any = {};
    console.log(obj);
   
    param.param1 = obj["scheduleAppointment"]["patient"]["firstName"] + " " + obj["scheduleAppointment"]["patient"]["lastName"];
    if (obj["scheduleAppointment"]["scheduledOnStr"]) {
      param.param2 = new Date(obj["scheduleAppointment"]["scheduledOnStr"]);
    }
    param.param3 = obj["scheduleAppointment"]["insuranceName"];
    param.param4 = obj["scheduleAppointment"]["insuranceType"];
    param.param5 = (obj["scheduleAppointment"]["IdNumber"] && obj["scheduleAppointment"]["IdNumber"] != 'null')?obj["scheduleAppointment"]["IdNumber"]:"";
    param.param7 = (obj["scheduleAppointment"]["groupId"] && obj["scheduleAppointment"]["groupId"] != 'null')?obj["scheduleAppointment"]["groupId"]:"";
    param.param6 = obj["tcProcedure"]["procedureInfo"]["procedureName"];
    param.param8 = obj["scheduleAppointment"]["physician"]?(obj["scheduleAppointment"]["physician"]["firstName"]+" "+ obj["scheduleAppointment"]["physician"]["lastName"]):"";
    param.param9 = obj["scheduleAppointment"]["physician"]?obj["scheduleAppointment"]["physician"]["taxId"]:"";
    param.param10 = obj["scheduleAppointment"]["physician"]?obj["scheduleAppointment"]["physician"]["dpi"]:"";
    param.param11 = obj["amount"];
    param.param12 = obj.id;
    console.log(param);
    
    return param;
  }
  private getColumnOrder() {
    this.destroyComponent[
      "orderSubsciber"
    ] = this.supportService.gridSortingHeader.subscribe((result: any) => {
      if (result && (result["name"] || result["order"])) {
        this.pageOrder["sortColumn"] = result["name"];
        this.pageOrder["sortType"] = result["order"];
        this.getColumnData(this.pageOrder);
      }
    });
  }
  ngOnDestroy() {
    Object.keys(this.destroyComponent).forEach((key, i) => {
      if (this.destroyComponent[key]) {
        this.destroyComponent[key].unsubscribe();
      }
    });
  }
  pageChanged(event) {
    this.currentPage = event.page;
    this.pageOrder["pageNumber"] = event.page;
    this.getColumnData(this.pageOrder);
  }
  generate() {
    this.currentPage = 1;
    if ((this.fromDate && !this.toDate) || (!this.fromDate && this.toDate)) {
      this.errorMessage = "Please choose start or end date";
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
      return null;
    }
    if (this.fromDate && this.fromDate["date"]) {
      this.pageOrder["startDate"] = moment(
        new Date(
          this.fromDate["date"]["year"],
          this.fromDate["date"]["month"] - 1,
          this.fromDate["date"]["day"]
        )
      ).format("YYYY-MM-DD");
    }
    if (this.toDate && this.toDate["date"]) {
      this.pageOrder["endDate"] = moment(
        new Date(
          this.toDate["date"]["year"],
          this.toDate["date"]["month"] - 1,
          this.toDate["date"]["day"]
        )
      ).format("YYYY-MM-DD");
    }
    if (!this.fromDate) {
      this.pageOrder["startDate"] = "";
    }
    if (!this.toDate) {
      this.pageOrder["endDate"] = "";
    }
    this.getColumnData(this.pageOrder);
  }

  blurOnChange(ev) {
    this.currentPage = 1;
    if (ev) {
      this.pageOrder["search"] = ev;
      this.getColumnData(this.pageOrder);
    } else {
      this.pageOrder["search"] = "";
      this.getColumnData(this.pageOrder);
    }
  }

  checkDate(str) {
    return checkDateUtil(str);
  }

  previousdateobj: any;
  onInputFieldChanged(event: IMyDateModel, str: string) {
    const today = new Date(event.jsdate);
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    this.previousdateobj = {
      day: this.checkDate(yesterday.getDate()),
      month: this.checkDate(yesterday.getMonth() + 1),
      year: yesterday.getFullYear(),
    };

    if (event && event.date && str === "fromDateStr") {
      const copy: IMyDpOptions = this.getCopyOfEndDateOptions2();
      copy.disableUntil = this.previousdateobj;
      this.myDatePickerOptions2 = copy;
      this.toDate = "";
    }
  }
  private getCopyOfEndDateOptions2(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerOptions2));
  }
  private getCopyOfEndDateOptions1(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerOptions1));
  }
  savePdf(ev) {
    const pageOrder = this.clearCacheItem("savePdf");
    const param = pageOrder;
    this.api.getAllInsurenceBillingReport(param).subscribe((res: any) => {
      if (res && res["entity"] && res["entity"]["pdfFileURL"]) {
        const fileName = res["entity"]["pdfFileURL"].substring(
          res["entity"]["pdfFileURL"].lastIndexOf("/"),
          res["entity"]["pdfFileURL"].length
        );
        if (fileName) {
          saveAs(res["entity"]["pdfFileURL"], fileName);
        }
      } else {
        this.errorMessage = "No record found";
        setTimeout(() => {
          this.errorMessage = "";
        }, 5000);
      }
    });
  }

  private clearCacheItem(pdf?) {
    if (this.fromDate && this.fromDate["date"]) {
      this.pageOrder["startDate"] =
        this.checkDate(this.fromDate["date"]["year"]) +
        "-" +
        this.checkDate(this.fromDate["date"]["month"]) +
        "-" +
        this.checkDate(this.fromDate["date"]["day"]);
    }
    if (this.toDate && this.toDate["date"]) {
      this.pageOrder["endDate"] =
        this.checkDate(this.toDate["date"]["year"]) +
        "-" +
        this.checkDate(this.toDate["date"]["month"]) +
        "-" +
        this.checkDate(this.toDate["date"]["day"]);
    }
    if (!this.fromDate) {
      this.pageOrder["startDate"] = "";
    }
    if (!this.toDate) {
      this.pageOrder["endDate"] = "";
    }
    const data = {
      pageNumber: 0,
      pageRecord: 0,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: this.pageOrder["startDate"],
      endDate: this.pageOrder["endDate"],
      sortColumn: this.pageOrder["sortColumn"],
      sortType: this.pageOrder["sortType"],
      search: this.pageOrder["search"] ? this.pageOrder["search"] : "",
    };

    return data;
  }
  refreshAll() {
    this.pageOrder["search"] = "";
    this.insurancevalue = "";
    this.fromDate = "";
    this.toDate = "";
    this.generate();
  }
}
